var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-list-comp"},[(_vm.items.length)?_c('div',{staticClass:"card-list"},_vm._l((_vm.items),function(course,index){return _c('course-overview-card-comp',{key:index,attrs:{"mall-course":course,"type":"order"}})}),1):_c('p-e-empty-info',{attrs:{"tip":"没有课程订单"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }